import * as React from "react";
import Svg, { Path } from "react-native-svg";

const BabyIcon = (props) => (
  <Svg
    width={22}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M11 2.234h-.009a8.774 8.774 0 1 0-.008 17.549A8.774 8.774 0 0 0 11 2.234Zm0 16.5a7.734 7.734 0 0 1-1.023-15.4C9.118 4.83 9.11 6.12 9.11 6.187a1.89 1.89 0 0 0 3.782 0 .516.516 0 1 0-1.032 0 .86.86 0 0 1-1.718 0c0-.008.025-1.443 1.108-2.913A7.734 7.734 0 0 1 11 18.734ZM7.906 11.86a.859.859 0 1 1 0-1.717.859.859 0 0 1 0 1.717ZM14.953 11a.86.86 0 1 1-1.719 0 .86.86 0 0 1 1.72 0Zm-1.246 3.154a.515.515 0 0 1-.138.713 4.658 4.658 0 0 1-5.139 0 .517.517 0 0 1 .576-.86 3.6 3.6 0 0 0 3.988 0 .515.515 0 0 1 .713.147Z"
      fill={props.color}
    />
  </Svg>
);
BabyIcon.defaultProps = {
  color: "#545454",
};
export default BabyIcon;
